import { render, staticRenderFns } from "./NurseBookingInvoice.vue?vue&type=template&id=afaf373a&scoped=true&"
import script from "./NurseBookingInvoice.vue?vue&type=script&lang=js&"
export * from "./NurseBookingInvoice.vue?vue&type=script&lang=js&"
import style0 from "./NurseBookingInvoice.vue?vue&type=style&index=0&id=afaf373a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaf373a",
  null
  
)

export default component.exports